import { ComponentConfig } from '../../../config/types';
import { setConfigStateById } from '../ConfigContext';

export const setComponentsConfig = (setState: setConfigStateById) => (componentConfigs: ComponentConfig[]) => {
  setState('SET_COMPONENTS_CONFIG', (s) => {
    const newIds = Array.from(componentConfigs, (c) => c.id);
    const untouchedComponentsConfig = s.componentsConfig.filter((e) => !newIds.includes(e.id));
    return {
      ...s,
      componentsConfig: [...untouchedComponentsConfig, ...componentConfigs],
    };
  });
};
